import { createContext } from 'react'

export const LocaleContext =
  createContext<{ locale: 'en' | 'pl', t: (val: string) => string }>
    ({ locale: 'pl', t: (val: string) => val })